import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { USAGE_QUERY_KEY } from "../../hooks/useUsage";
import { formatLocalDateTime, IS_TOP_UP_ENABLED, USAGE_LIMIT_EVENT, } from "../../services/usageLimits";
const TITLES = {
    rfc_daily: "Daily Ready For Change limit reached",
    export_daily: "Daily export limit reached",
    credits: "Not enough credits",
    subscription: "No active plan",
    capacity_reached: "We're at capacity for today",
};
/**
 * One place that turns a 429 limit response into an upgrade or top-up prompt, whichever page triggered it.
 * API calls raise it through reportUsageLimit().
 */
const UsageLimitDialog = () => {
    const [limit, setLimit] = useState(null);
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    useEffect(() => {
        const handleLimit = (event) => {
            setLimit(event.detail);
            queryClient.invalidateQueries(USAGE_QUERY_KEY);
        };
        window.addEventListener(USAGE_LIMIT_EVENT, handleLimit);
        return () => window.removeEventListener(USAGE_LIMIT_EVENT, handleLimit);
    }, [queryClient]);
    if (!limit)
        return null;
    const title = limit.error === "capacity_reached" ? TITLES.capacity_reached : TITLES[limit.limit];
    const close = () => setLimit(null);
    const upgradeUrl = limit.error === "limit_reached" ? limit.upgrade_url : null;
    const topupPath = IS_TOP_UP_ENABLED && limit.error === "limit_reached" ? limit.topup_url : null;
    return (_jsxs(Dialog, Object.assign({ open: true, onClose: close, maxWidth: "xs", fullWidth: true }, { children: [_jsx(DialogTitle, { children: title }), _jsxs(DialogContent, { children: [_jsx(Typography, Object.assign({ variant: "body2" }, { children: limit.message })), limit.resets_at && (_jsxs(Typography, Object.assign({ variant: "body2", color: "text.secondary", sx: { mt: 1.5 } }, { children: ["Resets ", formatLocalDateTime(limit.resets_at), " (your time)."] })))] }), _jsxs(DialogActions, { children: [_jsx(Button, Object.assign({ onClick: close }, { children: "Close" })), topupPath && (_jsx(Button, Object.assign({ variant: "outlined", onClick: () => {
                            close();
                            navigate(topupPath);
                        } }, { children: "Top up credits" }))), upgradeUrl && (_jsx(Button, Object.assign({ variant: "contained", href: upgradeUrl, target: "_blank", rel: "noopener noreferrer", onClick: close }, { children: "Upgrade plan" }))), !(upgradeUrl || topupPath) && limit.error === "limit_reached" && (_jsx(Button, Object.assign({ variant: "contained", onClick: () => {
                            close();
                            navigate("/usage");
                        } }, { children: "View usage" })))] })] })));
};
export default UsageLimitDialog;
